export const ICONS_SVG_PATH =
    process.env.NODE_ENV !== 'development' || process.env.IS_PROXY_MODE === 'true'
        ? '/_ui/global/images/icons-sprite.svg'
        : '/images/icons-sprite.svg';

export const ICONS_SVG_VERSION = '260607';

export const IMAGES_PATH = process.env.NODE_ENV !== 'development' ? '/_ui/global/images' : '/images';